/**
 * List of all our pathname, based on country, for intratone.info.
 * Exemple: It can be used to authorize or deny certain contents
 */

export const countryList = {
    // production, test and dev
    fr: false,
    en: false,
    "ch-fr": false,
    "ch-de": false,
    dk: false,
    fi: false,
    de: false,
    "be-fr": false,
    "be-fl": false,
    "lu-fr": false,
    "lu-de": false,
    no: false,
    nl: false,
    se: false,
    es: false,
    it: false,

    // Tmp
    tmp: false, // -> tmp FR
    tmpen: false,
    tmpdk: false,
    tmpfi: false,
    tmpde: false,
    tmpno: false,
    tmpnl: false,
    tmpse: false,
    tmpes: false,
    tmpit: false,
}
